import React from 'react'
import { useIntl } from 'react-intl'
import capitalize from 'lodash/capitalize'
import { twMerge } from 'tailwind-merge'
import type { IconName } from 'msp-integrations'
import { Icons } from 'msp-components'
import translations from './PaymentMethodDisplay.constants'
import { PaymentMethodTypeCardProps } from './PaymentMethodDisplay.types'
import * as S from './PaymentMethodDisplay.styles'

const PaymentMethodTypeCard = ({
  className = '',
  paymentInstrument
}: PaymentMethodTypeCardProps) => {
  const { formatMessage } = useIntl()
  let iconName = 'DebitCard'
  const cardType = paymentInstrument.paymentCard.cardType

  // We only have specific icons for VISA and MASTER card types
  if (cardType === 'VISA' || cardType === 'MASTER') {
    iconName = `${capitalize(cardType)}Card` as IconName
  }

  const cardDescription =
    cardType === 'MAESTRO'
      ? 'Maestro'
      : formatMessage(translations.UNZER_CARDS, {
          cardType: iconName
        })

  const { paymentCard } = paymentInstrument
  const expirationMonth =
    paymentCard.expirationMonth < 10
      ? '0' + paymentCard.expirationMonth
      : paymentCard.expirationMonth

  return (
    <div className={twMerge(S.PaymentMethodDisplayWrapper, className)}>
      <div className={S.PaymentMethodDisplayIconWrapper}>
        <Icons iconName={iconName} size='3xl' />
      </div>
      <div className={S.PaymentMethodDisplayContentWrapper}>
        <div className={S.PaymentMethodDisplayNameWrapper}>
          {cardDescription}
          {paymentCard.creditCardExpired && (
            <span className={S.PaymentMethodDisplayExpiredWrapper}>
              {formatMessage(translations.creditCardExpired)}
            </span>
          )}
        </div>
        <div className={S.PaymentMethodDisplayStandardWrapper}>
          {paymentCard.holder}
        </div>
        <div className={S.PaymentMethodDisplayStandardWrapper}>
          {formatMessage(translations.creditCardNumber, {
            number: paymentCard.maskedNumber
          })}
        </div>
        <div className={S.PaymentMethodDisplayStandardWrapper}>
          {formatMessage(translations.creditCardValidity, {
            expiryDate: `${expirationMonth} / ${paymentCard.expirationYear}`
          })}
        </div>
      </div>
    </div>
  )
}

export default PaymentMethodTypeCard
